export default {
    pages: state => state.pages,
    termsTitle: state => state.termsTitle,
    termsContent: state => state.termsContent,
    categories: state => state.categories
}